import { FormsManager } from "@/components/FormsManager";

export default function FormsPage() {
  return (
    <div className="px-6 md:px-12 py-8" data-testid="admin-forms-page">
      <FormsManager />
    </div>
  );
}
